import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ClaimDto} from "../../../auto-generated-server-dtos/list-claims/claim-dto";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ListClaimsService {

  constructor(private httpClient: HttpClient) {
  }

  listClaims(ajaxSettings: DataTables.AjaxSettings, p: {}) {
    return this.httpClient.get<ClaimDto[]>(`${environment.apiServer}/ListClaims`);
  }
}
